/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';

import NotificationsContext from '../contexts/NotificationsContext';

const NotificationsPanel = () => {
  const { isPanelOpened, notifications, setIsPanelOpened } =
    useContext(NotificationsContext);

  const closePanel = () => {
    setIsPanelOpened(false);
  };

  useEffect(() => {
    if (!isPanelOpened) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [isPanelOpened]);

  useEffect(() => {
    // console.log(notifications);
  }, [notifications]);

  return (
    <>
      <div
        className={`notificationsPanel ${isPanelOpened && 'opened'} `}
        onClick={closePanel}
      >
        <div className='notificationsPanel__container'>
          {/* <button onClick={closePanel}>x</button> */}
          <h3>Notifications</h3>
          {notifications.map((item) => {
            return (
              <div key={item.id} className='notificationsPanel__item'>
                <div
                  className={`notificationsPanel__item__image ${item.type} ${item.status}`}
                >
                  <img loading='auto' src={item.body.image} alt={item.detail?.name} />
                </div>

                <div>
                  <span className={`notificationsPanel__item__status ${item.status}`}>
                    {item.status}
                  </span>
                  <p className='notificationsPanel__item__title'>
                    {item.body.name?.first} {item.body.name?.last}
                  </p>
                  <p className='notificationsPanel__item__detail'>
                    {item.body.detail?.name} {item.body.detail?.number}
                  </p>

                  <p className='notificationsPanel__item__price'>
                    {item.body.detail?.days} {item.body.detail?.message}{' '}
                    <b>{item.body.detail?.currency}</b> {item.body.detail?.price}
                  </p>

                  <div className='notifications__item__actions'>
                    <Link to='/'>Leer más &gt;</Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default NotificationsPanel;
